export class DynamicSettings {
  settingKey: string;
  settingArea: string;

  constructor(init: DynamicSettings) {
    Object.assign(this, init);
  }
}
